module.exports = __webpack_public_path__ + "img/9.84ca91f2.jpg";